/**
 * NovaAdventurer — "Adventurer" persona tile. Fedora on. Photo first, whip second, questions later.
 * Timing: 10s story · flash · whip · 3 moods. Geometry generated from the canonical Character
 * Bible catalog (nova.js) — regenerate rather than hand-editing paths.
 * Animations come from nova.css via the `expr-indy` wrapper class
 * (applied by <NovaExpression id="indy" />).
 */
import * as React from "react";

export function NovaAdventurer({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 460 460" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Nova the adventurer">
      
        
      <defs>
        <linearGradient id="bodyG-n3" x1="0.15" y1="0" x2="0.85" y2="1">
          <stop offset="0" stopColor="#709c9e"/>
          <stop offset="0.45" stopColor="#2D6E70"/>
          <stop offset="1" stopColor="#1e494a"/>
        </linearGradient>
        <linearGradient id="chestG-n3" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#174143"/>
          <stop offset="1" stopColor="#3a6b6d"/>
        </linearGradient>
        <radialGradient id="scrG-n3" cx="0.5" cy="0.45" r="0.8">
          <stop offset="0" stopColor="#0E1626"/>
          <stop offset="0.72" stopColor="#0E1626"/>
          <stop offset="1" stopColor="#060A12"/>
        </radialGradient>
        <pattern id="pxg-n3" width="9" height="9" patternUnits="userSpaceOnUse">
          <path d="M 9 0 L 0 0 0 9" fill="none" stroke="#060A12" strokeWidth="1.6" opacity="0.65"/>
        </pattern>
        <filter id="eglow-n3" x="-60%" y="-60%" width="220%" height="220%">
          <feGaussianBlur stdDeviation="6"/>
        </filter>
      </defs>
        <g transform="translate(50 0)">
        
        
        <g className="nova-body" style={{ transformOrigin: "180.00px 472.00px" }} transform="rotate(0 180 347)">
          {/* Antenna stem (drawn first so head covers its base) */}
          <line x1="180" y1="122" x2="180" y2="42.60000000000001" stroke="#1C1A17" strokeWidth="2.2" strokeLinecap="round"/>
          {/* Orbital ring (behind ball, ivory) */}
          <ellipse cx="180" cy="42.60000000000001" rx="15" ry="5.3999999999999995" stroke="#F4EFE6" strokeWidth="1.6" fill="none" transform="rotate(-12 180 42.60000000000001)"/>
          {/* Antenna ball */}
          <circle className="antenna-ball" cx="180" cy="42.60000000000001" r="7" fill="#D4541F"/>
          <ellipse cx="177.9" cy="40.150000000000006" rx="2.94" ry="2.1" fill="#FFFFFF" opacity="0.55"/>
          {/* Front half of orbital ring (over ball) so it appears to encircle */}
          <path d="M 165.3 43.10000000000001 A 15 5.3999999999999995 -12 0 0 194.7 40.400000000000006"
                stroke="#F4EFE6" strokeWidth="1.6" fill="none" opacity="0.95"/>
          
    
          {/* HEAD outer (glossy) */}
          <rect x="60" y="110" width="240" height="170" rx="36" fill="url(#bodyG-n3)"/>
          {/* Bezel inset (darker ring) */}
          <rect x="82" y="132" width="196" height="126" rx="28" fill="#1F5759"/>
          {/* Face screen: recessed navy display */}
          <rect x="88" y="138" width="184" height="114" rx="22" fill="url(#scrG-n3)"/>
    
          {/* Cheeks (on teal head, flanking screen) */}
          
    
          {/* Eyes: glow pass + sharp pass */}
          <g filter="url(#eglow-n3)" opacity="0.75">
          
          <g className="eye-left" style={{ transformOrigin: "146.88px 195.00px" }}><path d="M 143.35 169.39 Q 145.24 163.69 147.71 169.16 L 170.47 219.56 Q 172.94 225.03 166.95 225.34 L 130.09 227.27 Q 124.10 227.59 125.99 221.89 Z" fill="#A8C8E8" opacity="1"/></g>
          <g className="eye-right" style={{ transformOrigin: "213.12px 195.00px" }}><path d="M 212.29 169.16 Q 214.76 163.69 216.65 169.39 L 234.01 221.89 Q 235.90 227.59 229.91 227.27 L 193.05 225.34 Q 187.06 225.03 189.53 219.56 Z" fill="#A8C8E8" opacity="1"/></g>
        </g>
          
          
          <g className="eye-left" style={{ transformOrigin: "146.88px 195.00px" }}><path d="M 143.35 169.39 Q 145.24 163.69 147.71 169.16 L 170.47 219.56 Q 172.94 225.03 166.95 225.34 L 130.09 227.27 Q 124.10 227.59 125.99 221.89 Z" fill="#A8C8E8" opacity="1"/></g>
          <g className="eye-right" style={{ transformOrigin: "213.12px 195.00px" }}><path d="M 212.29 169.16 Q 214.76 163.69 216.65 169.39 L 234.01 221.89 Q 235.90 227.59 229.91 227.27 L 193.05 225.34 Q 187.06 225.03 189.53 219.56 Z" fill="#A8C8E8" opacity="1"/></g>
        
    
          {/* Single quiet tear (Sad) — on face screen, below right eye */}
          
    
          {/* Pixel grid over the display (LED look) */}
          <rect x="88" y="138" width="184" height="114" rx="22" fill="url(#pxg-n3)"/>
          {/* Screen glare */}
          <ellipse cx="146.88" cy="148" rx="55.199999999999996" ry="9" fill="#8FB4E8" opacity="0.13"/>
          {/* Head specular */}
          <ellipse cx="112" cy="126" rx="36" ry="9" fill="#FFFFFF" opacity="0.35" transform="rotate(-10 112 126)"/>
    
          {/* BODY outer (glossy) */}
          <rect x="50" y="302" width="260" height="170" rx="36" fill="url(#bodyG-n3)"/>
          {/* Chest storage: interior + items behind a hinged door */}
          <rect x="72" y="324" width="216" height="126" rx="26" fill="#0B1220"/>
          <g className="chest-items" style={{ opacity: "0" }}>
            <path d="M 141.12 358 l 6.2 12.7 13.9 2 -10 9.8 2.4 13.9 -12.5 -6.6 -12.5 6.6 2.4 -13.9 -10 -9.8 13.9 -2 Z" fill="#D4A02C"/>
            <g transform="translate(190.8 368)">
              <rect x="0" y="0" width="44" height="30" rx="5" fill="#1C1A17"/>
              <circle cx="22" cy="15" r="9" fill="#3A3733" stroke="#F4EFE6" strokeWidth="1.4"/>
              <rect x="31" y="3" width="8" height="5" rx="1.5" fill="#3A3733"/>
            </g>
          </g>
          {/* Chest door (hinged at left edge) */}
          <g className="chest-door" style={{ transformOrigin: "74px 387.0px" }}>
            <rect x="72" y="324" width="216" height="126" rx="26" fill="url(#chestG-n3)"/>
            <line x1="79" y1="336" x2="79" y2="438" stroke="#0B1220" strokeWidth="2.4" opacity="0.55"/>
            <circle cx="272" cy="387.0" r="5" fill="#6d9293"/>
          </g>
          {/* Body specular */}
          <ellipse cx="98" cy="316" rx="30" ry="7" fill="#FFFFFF" opacity="0.25" transform="rotate(-8 98 316)"/>
    
          {/* Arms (drawn over body) */}
          
          {/* right arm bent up */}
          <path d="M 296 362 Q 334 312 318 272" stroke="#1C1A17" strokeWidth="11" strokeLinecap="round" fill="none"/>
          {/* camera body, held near her shoulder */}
          <g className="camera" transform="translate(288 246)">
            <rect x="0" y="0" width="58" height="40" rx="5" fill="#1C1A17"/>
            <rect x="0" y="26" width="58" height="14" fill="#1F5759"/>
            <circle className="lens-ring" cx="29" cy="20" r="11" fill="#1F5759" stroke="#F4EFE6" strokeWidth="1.4"/>
            <circle className="lens-iris" cx="29" cy="20" r="6" fill="#1C1A17" style={{ transformOrigin: "29px 20px" }}/>
            <rect className="lens-flash" x="0" y="0" width="58" height="40" rx="5" fill="#F4EFE6" opacity="0"/>
            <rect x="40" y="4" width="10" height="6" rx="1.5" fill="#1F5759"/>
          </g>
          {/* left arm small at side */}
          <path d="M 64 362 Q 44 390 54 412" stroke="#1C1A17" strokeWidth="11" strokeLinecap="round" fill="none"/>
          <circle cx="54" cy="414" r="8" fill="#1C1A17"/>
        
        </g>
        </g>
      
      <g transform="translate(50 0)">
        {/* eye-mask overlays live on the face screen (x88-272, y138-252) */}
        <g className="indy-shocked-eyes" style={{ opacity: "0" }}>
          <rect x="100" y="150" width="160" height="90" rx="16" fill="#0E1626"/>
          <ellipse cx="147" cy="195" rx="19" ry="24" fill="#A8C8E8"/>
          <ellipse cx="213" cy="195" rx="19" ry="24" fill="#A8C8E8"/>
          <circle cx="150" cy="195" r="6" fill="#1C1A17"/>
          <circle cx="216" cy="195" r="6" fill="#1C1A17"/>
        </g>
        <g className="indy-curious-eyes" style={{ opacity: "0" }}>
          <rect x="100" y="150" width="160" height="90" rx="16" fill="#0E1626"/>
          <path d="M 147 172 L 165 205 L 129 205 Z" fill="#A8C8E8" transform="rotate(12 147 192)"/>
          <path d="M 213 172 L 231 205 L 195 205 Z" fill="#A8C8E8" transform="rotate(-12 213 192)"/>
        </g>
        <g className="indy-happy-eyes" style={{ opacity: "0" }}>
          <rect x="100" y="150" width="160" height="90" rx="16" fill="#0E1626"/>
          <path d="M 122 199 Q 147 165 172 199" stroke="#A8C8E8" strokeWidth="11" strokeLinecap="round" fill="none"/>
          <path d="M 188 199 Q 213 165 238 199" stroke="#A8C8E8" strokeWidth="11" strokeLinecap="round" fill="none"/>
        </g>
        {/* fedora: wide brim, pinched crown, dark band */}
        <ellipse cx="180" cy="108" rx="98" ry="15" fill="#7A4E2A" stroke="#1C1A17" strokeWidth="3"/>
        <path d="M 126 108 Q 122 56 152 50 Q 180 62 208 50 Q 238 56 234 108 Z" fill="#8B5E34" stroke="#1C1A17" strokeWidth="3" strokeLinejoin="round"/>
        <rect x="126" y="92" width="108" height="13" fill="#4A2F16"/>
        {/* satchel strap across body */}
        <path d="M 92 320 L 258 462" stroke="#4A2F16" strokeWidth="13" strokeLinecap="round" opacity="0.9"/>
        {/* whip: coiled at her left side, pops in */}
        <g className="indy-whip" style={{ opacity: "0" }}>
          <path d="M 42 350 Q 60 380 42 404" stroke="#1C1A17" strokeWidth="10" strokeLinecap="round" fill="none"/>
          <circle cx="34" cy="378" r="26" fill="none" stroke="#4A2F16" strokeWidth="9"/>
          <circle cx="34" cy="378" r="13" fill="none" stroke="#4A2F16" strokeWidth="8"/>
          <rect x="24" y="322" width="14" height="34" rx="6" fill="#1C1A17"/>
        </g>
      </g>
    </svg>
  );
}
